module.exports = __webpack_public_path__ + "static/media/ic_app_store.9a692c98.svg";